import { themes } from '@theme/initThemes';
import layout1Settings from './Setting/LayoutSettings';

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const LayoutSettings = {
  activeLayout: 'layout1', // layout1, layout2
  activeTheme: 'green', // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js

  secondarySidebar: {
    show: true,
    open: false,
    theme: 'whitePurple' // View all valid theme colors inside MatxTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: true,
    fixed: false,
    theme: 'whitePurple' // View all valid theme colors inside MatxTheme/themeColors.js
  }
};
